module.exports = __webpack_public_path__ + "static/media/entlastung.a76c77fc.jpg";